<div>
  <h3 nz-typography translate>payment.receiverInfo.title</h3>

  <app-collapse
    [headerKey]="'payment.receiverInfo.identification.title'"
    [active]="isBeneficiaryTypeSectionForcedOpen || isSectionExpanded('beneficiaryType')"
    (activeChange)="onSectionActiveChange('beneficiaryType', $event)"
  >
    <nz-form-item>
      <nz-form-label translate>payment.receiverInfo.beneficiary.title</nz-form-label>
      <nz-form-control>
        <nz-select
          nzSize="large"
          nzShowSearch
          l10n-placeholder
          [nzPlaceHolder]="'payment.receiverInfo.beneficiary.placeholder' | translate: locale.language"
          [formControl]="beneficiaryCategory"
          data-cy="beneficiaryCategory"
        >
          @for (identificationClass of PaymentIdentificationClasses; track identificationClass) {
          <nz-option
            [nzValue]="identificationClass"
            [nzLabel]="'payment.identification.classifier.' + identificationClass | translate: locale.language"
          ></nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    @if (shouldShowBeneficiaryIdentification) {
    <ng-container *ngTemplateOutlet="beneficiaryIdentificationTemplate"></ng-container>
    } @for (param of additionalFields ?? []; track param.name) { @if (['beneficiaryIdentificationCodeType',
    'beneficiaryIdentificationCode'].includes(param.name) && shouldShowInlineIdentificationField(param.name)) {
    <ng-container *ngTemplateOutlet="fieldTemplate; context: { param: param, formGroupName: null }"></ng-container>
    } }
  </app-collapse>

  @if ( sectionFields.beneficiaryDetails?.length || controlNameExists('beneficiaryPhoneNumber') || (showNameControl &&
  form.get('beneficiaryIdentificationName')?.enabled) || form.get('beneficiaryIdentificationSurname')?.enabled ) {
  <app-collapse
    [headerKey]="'payment.receiverInfo.title'"
    [active]="isSectionExpanded('beneficiaryDetails')"
    (activeChange)="onSectionActiveChange('beneficiaryDetails', $event)"
  >
    @if (showNameControl && form.get('beneficiaryIdentificationName')?.enabled) {
    <nz-form-item>
      <nz-form-label>{{ nameControlLabelKey | translate: locale.language }} </nz-form-label>
      <nz-form-control>
        <input
          nz-input
          nzSize="large"
          type="text"
          [placeholder]="nameControlLabelKey | translate: locale.language"
          [formControl]="form.get('beneficiaryIdentificationName')"
          [maxlength]="nameMaxLength"
          [minlength]="config.beneficiaryNameMinLength"
          data-cy="beneficiaryIdentificationName"
        />
      </nz-form-control>
    </nz-form-item>
    } @if (form.get('beneficiaryIdentificationSurname')?.enabled) {
    <nz-form-item>
      <nz-form-label translate>reg.details.personSurname.label</nz-form-label>
      <nz-form-control>
        <input
          nz-input
          nzSize="large"
          type="text"
          [placeholder]="'reg.details.personSurname.label' | translate: locale.language"
          [formControl]="form.get('beneficiaryIdentificationSurname')"
          [maxlength]="nameMaxLength"
          [minlength]="config.beneficiaryNameMinLength"
          data-cy="beneficiaryIdentificationSurname"
        />
      </nz-form-control>
    </nz-form-item>
    } @for (param of sectionFields.beneficiaryDetails ?? []; track param.name) {
    <ng-container *ngTemplateOutlet="fieldTemplate; context: { param: param, formGroupName: null }"></ng-container>
    }

    <ng-container *ngTemplateOutlet="phoneFieldTemplate; context: { name: 'beneficiaryPhoneNumber' }"></ng-container>
  </app-collapse>
  } @if (sectionFields.beneficiaryAddress?.length) {
  <app-collapse
    [headerKey]="'payment.receiverInfo.address.title'"
    [active]="isSectionExpanded('beneficiaryAddress')"
    (activeChange)="onSectionActiveChange('beneficiaryAddress', $event)"
  >
    @for (param of sectionFields.beneficiaryAddress ?? []; track param.name) {
    <ng-container *ngTemplateOutlet="fieldTemplate; context: { param: param, formGroupName: null }"></ng-container>
    }
  </app-collapse>
  } @if ( sectionFields.ultimateBeneficiary?.length || sectionFields.ultimateBeneficiaryAddress?.length || controlNameExists('ultimateBeneficiaryPhoneNumber')
  || shouldShowUltimateBeneficiaryIdentification ) {
  <app-collapse
    [headerKey]="'payment.receiverInfo.ultimate.title'"
    [active]="isSectionExpanded('ultimateBeneficiary')"
    (activeChange)="onSectionActiveChange('ultimateBeneficiary', $event)"
  >
    @for (param of sectionFields.ultimateBeneficiary ?? []; track param.name) {
    <ng-container *ngTemplateOutlet="fieldTemplate; context: { param: param, formGroupName: null }"></ng-container>
    }

    <ng-container *ngTemplateOutlet="phoneFieldTemplate; context: { name: 'ultimateBeneficiaryPhoneNumber' }"></ng-container>

    @if (shouldShowUltimateBeneficiaryIdentification) {
    <app-collapse
      [headerKey]="'payment.receiverInfo.identify.title'"
      [active]="isSectionExpanded('ultimateBeneficiaryIdentification')"
      (activeChange)="onSectionActiveChange('ultimateBeneficiaryIdentification', $event)"
    >
      <ng-container *ngTemplateOutlet="ultimateBeneficiaryIdentificationTemplate"></ng-container>
    </app-collapse>
    } @if (sectionFields.ultimateBeneficiaryAddress?.length) {
    <app-collapse
      [headerKey]="'payment.receiverInfo.ultimate.address.title'"
      [active]="isSectionExpanded('ultimateBeneficiaryAddress')"
      (activeChange)="onSectionActiveChange('ultimateBeneficiaryAddress', $event)"
    >
      @for (param of sectionFields.ultimateBeneficiaryAddress ?? []; track param.name) {
      <ng-container *ngTemplateOutlet="fieldTemplate; context: { param: param, formGroupName: null }"></ng-container>
      }
    </app-collapse>
    }
  </app-collapse>
  } @if (sectionFields.beneficiaryBank?.length) {
  <app-collapse
    [headerKey]="'payment.receiverInfo.additionalBankIdentification.title'"
    [active]="isSectionExpanded('beneficiaryBank')"
    (activeChange)="onSectionActiveChange('beneficiaryBank', $event)"
  >
    @for (param of sectionFields.beneficiaryBank ?? []; track param.name) {
    <ng-container *ngTemplateOutlet="fieldTemplate; context: { param: param, formGroupName: null }"></ng-container>
    }
  </app-collapse>
  } @if (sectionFields.correspondentBank?.length) {
  <app-collapse
    [headerKey]="'payment.receiverInfo.correspondentBank.title'"
    [active]="isSectionExpanded('correspondentBank')"
    (activeChange)="onSectionActiveChange('correspondentBank', $event)"
  >
    @for (param of sectionFields.correspondentBank ?? []; track param.name) {
    <ng-container *ngTemplateOutlet="fieldTemplate; context: { param: param, formGroupName: null }"></ng-container>
    }
  </app-collapse>
  } @if (shouldShowPayerInfo) {
  <h3 nz-typography translate>payment.payerInfo.title</h3>
  } @if (shouldShowPayerAddress) {
  <app-collapse
    [headerKey]="'payment.payerInfo.address.title'"
    [active]="isSectionExpanded('payerAddress')"
    (activeChange)="onSectionActiveChange('payerAddress', $event)"
  >
    @for (param of sectionFields.payerAddress ?? []; track param.name) {
    <ng-container *ngTemplateOutlet="fieldTemplate; context: { param: param, formGroupName: null }"></ng-container>
    }
  </app-collapse>
  } @if (shouldShowPayerIdentificationSection) {
  <app-collapse
    [headerKey]="'payment.payerInfo.payerIdentification.title'"
    [active]="isSectionExpanded('payerIdentification')"
    (activeChange)="onSectionActiveChange('payerIdentification', $event)"
  >
    @if (shouldShowPayerIdentification) {
    <ng-container *ngTemplateOutlet="payerIdentificationTemplate"></ng-container>
    } @for (param of sectionFields.payerIdentificationFallback ?? []; track param.name) {
    <ng-container *ngTemplateOutlet="fieldTemplate; context: { param: param, formGroupName: null }"></ng-container>
    }
  </app-collapse>
  } @if (shouldShowInitialPayer) {
  <app-collapse
    [headerKey]="'payment.payerInfo.initial.title'"
    [active]="isSectionExpanded('initialPayer')"
    (activeChange)="onSectionActiveChange('initialPayer', $event)"
  >
    @for (param of sectionFields.initialPayer ?? []; track param.name) {
    <ng-container *ngTemplateOutlet="fieldTemplate; context: { param: param, formGroupName: null }"></ng-container>
    }

    <ng-container *ngTemplateOutlet="phoneFieldTemplate; context: { name: 'initialPayerPhoneNumber' }"></ng-container>

    @if (shouldShowInitialPayerIdentification) {
    <app-collapse
      [headerKey]="'payment.payerInfo.identify.title'"
      [active]="isSectionExpanded('initialPayerIdentification')"
      (activeChange)="onSectionActiveChange('initialPayerIdentification', $event)"
    >
      <ng-container *ngTemplateOutlet="initialPayerIdentificationTemplate"></ng-container>
    </app-collapse>
    } @if (sectionFields.initialPayerAddress?.length) {
    <app-collapse
      [headerKey]="'payment.payerInfo.initial.address.title'"
      [active]="isSectionExpanded('initialPayerAddress')"
      (activeChange)="onSectionActiveChange('initialPayerAddress', $event)"
    >
      @for (param of sectionFields.initialPayerAddress ?? []; track param.name) {
      <ng-container *ngTemplateOutlet="fieldTemplate; context: { param: param, formGroupName: null }"></ng-container>
      }
    </app-collapse>
    }
  </app-collapse>
  } @if (shouldShowAdditionalInformation) {
  <h3 nz-typography translate>payment.additionalInformation</h3>

  @if (sectionFields.paymentIdentification?.length) {
  <app-collapse
    [headerKey]="'payment.payerInfo.paymentIdentification.title'"
    [active]="isSectionExpanded('paymentIdentification')"
    (activeChange)="onSectionActiveChange('paymentIdentification', $event)"
  >
    @for (param of sectionFields.paymentIdentification ?? []; track param.name) {
    <ng-container *ngTemplateOutlet="fieldTemplate; context: { param: param, formGroupName: null }"></ng-container>
    }
  </app-collapse>
  } @if (sectionFields.additionalInformation?.length || customFields?.length) {
  <app-collapse
    [headerKey]="'payment.additionalInformation'"
    [active]="isSectionExpanded('additionalInformation')"
    (activeChange)="onSectionActiveChange('additionalInformation', $event)"
  >
    @for (param of sectionFields.additionalInformation ?? []; track param.name) {
    <ng-container *ngTemplateOutlet="fieldTemplate; context: { param: param, formGroupName: null }"></ng-container>
    } @for (param of customFields ?? []; track param.name) {
    <ng-container *ngTemplateOutlet="fieldTemplate; context: { param: param, formGroupName: 'customFields' }"></ng-container>
    }
  </app-collapse>
  } }

  <ng-template #phoneFieldTemplate let-name="name">
    @if (shouldShowPhoneField(name)) {
    <nz-form-item>
      <nz-form-label [ngClass]="{ 'ant-form-item-label-required': isRequired(name) }">
        {{ 'payment.receiverInfo.' + name + '.label' | translate: locale.language }}
      </nz-form-label>
      <nz-form-control>
        <div>
          <input nz-input nzSize="large" type="text" appIntlTelInput [formControl]="form.get(name)" [attr.data-cy]="name" />
        </div>
      </nz-form-control>
    </nz-form-item>
    }
  </ng-template>

  <ng-template #fieldTemplate let-param="param" let-formGroupName="formGroupName">
    @if (formGroupName) {
    <nz-form-item>
      <nz-form-label>{{ routingCodeLabel(param, locale.language) }}</nz-form-label>
      <nz-form-control>
        @if (param.glossaryId) {
        <nz-select
          nzSize="large"
          nzShowSearch
          [nzPlaceHolder]="'payment.receiverInfo.routingCode.selectPlaceholder' | translate: locale.language"
          [formControl]="form.get(formGroupName)?.get(param.name)"
          (ngModelChange)="onGlossaryChange(param.name, $event, param.strictValue)"
          [attr.data-cy]="param.name"
          [nzFilterOption]="diacriticInsensitiveFilter"
        >
          @for (option of glossaryOptions[param.name] ?? []; track option.id) {
          <nz-option [nzValue]="option.id" [nzLabel]="option.label"></nz-option>
          }
        </nz-select>
        } @else {
        <input
          nz-input
          nzSize="large"
          type="text"
          [maxlength]="param.maxlength"
          [placeholder]="'payment.receiverInfo.routingCode.placeholder' | translate: locale.language"
          [formControl]="form.get(formGroupName)?.get(param.name)"
          [attr.data-cy]="param.name"
        />
        }
      </nz-form-control>
    </nz-form-item>
    } @else {
    <nz-form-item>
      <nz-form-label>{{ 'payment.receiverInfo.' + param.name + '.label' | translate: locale.language }} {{ param.label }}</nz-form-label>
      <nz-form-control>
        @if (shouldShowDropdown(param)) {
        <nz-select
          nzSize="large"
          nzShowSearch
          [nzPlaceHolder]="'payment.receiverInfo.' + param.name + '.selectPlaceholder' | translate: locale.language"
          [formControl]="form.get(param.name)"
          (ngModelChange)="onGlossaryChange(param.name, $event, param.strictValue)"
          [attr.data-cy]="param.name"
          [nzFilterOption]="diacriticInsensitiveFilter"
        >
          @for (option of glossaryOptions[param.name] ?? []; track option.id) {
          <nz-option [nzValue]="option.id" [nzLabel]="option.label"></nz-option>
          }
        </nz-select>
        } @else {
        <input
          nz-input
          nzSize="large"
          type="text"
          [maxlength]="param.maxlength"
          [placeholder]="'payment.receiverInfo.' + param.name + '.placeholder' | translate: locale.language"
          [formControl]="form.get(param.name)"
          [attr.data-cy]="param.name"
        />
        }
      </nz-form-control>
    </nz-form-item>
    } @if (param.glossaryId && glossaryOptions[param.name]?.length && form.get(param.name + '_other')) {
    <nz-form-item>
      <nz-form-label translate> {{ 'payment.receiverInfo.' + param.name + '.label' }} </nz-form-label>
      <nz-form-control>
        <input
          nz-input
          nzSize="large"
          type="text"
          [placeholder]="'payment.receiverInfo.' + param.name + '.placeholder' | translate: locale.language"
          [formControl]="form.get(param.name + '_other')"
          [maxlength]="param.maxlength"
        />
      </nz-form-control>
    </nz-form-item>
    }
  </ng-template>
</div>
